export const RuntimeErrorTrigger = () => {
	throw new Error("Intentional runtime error from RuntimeErrorTrigger");
};
